// 判断是否退款
export default {
  namespaced: true,
  state: {
    // true知道已签,false未签
    isKnowRefund: false // 是否知道自己退款
  },
  mutations: {
    SET_REFUND: (state, data) => {
      state.isKnowRefund = data
    }
  },
  actions: {
    setRefund ({ commit }, isRefund) {
      commit('SET_REFUND', isRefund)
    }
  }
}